const cryptoJS = require('crypto-js')
// const repo = 'shurintou.github.io'
// const owner = 'shurintou'
// const username = 'bd40dd16da37715c96f5'
// const password = '8853dce879c0f8a6ca9364f3f242b23dadeccfc1'
// const gitalkProps = {
//     clientID: username,
//     clientSecret: password,
//     repo: repo,
//     owner: owner,
//     admin: ['shurintou'],
// }


const cryptoSalt = '#5A8y9D3H'

// const cryptoStr = cryptoJS.AES.encrypt(JSON.stringify(gitalkProps), cryptoSalt).toString()
// console.log(cryptoStr)
const cryptoStr = 'U2FsdGVkX1/yP8nxmnwCgclip9zKyEs+uQjo/TvmWsLMppbKgdm8JT3LypvXZvgS2dIA9wm4el/No0W3juPeH/xISMIoPZ5pS9FwWue6tRfIOzXc3gm760yEM5+BD6siILxyAHue0vrgT8kd8fThQw5Gg+L1I0qvb7HQKn8Mavq7k3n2acrYnWbcJzzPbNXjHrH/HTaN0V/OkeT3lqWnlh9qmR2XfUACprQ4Gqh+8z6JCK2SxlCF70NYRdWRLuy0'


const auth = JSON.parse(cryptoJS.AES.decrypt(cryptoStr, cryptoSalt).toString(cryptoJS.enc.Utf8))


export default auth